import { OrderCard } from '../../../../components';
import { Grid2 as Grid, Skeleton, Stack } from '@mui/material';

export default function SkeletonCard() {
  return (
    <OrderCard>
      <Grid container spacing={2}>
        <Grid container size={12} spacing={1}>
          <Grid size={7}>
            <Skeleton variant="rounded" />
          </Grid>

          <Grid size={12}>
            <Stack direction="row" spacing={1}>
              <Skeleton
                variant="rounded"
                width={40}
                sx={{ borderRadius: 50 }}
              />
              <Skeleton
                variant="rounded"
                width={40}
                sx={{ borderRadius: 50 }}
              />
            </Stack>
          </Grid>
        </Grid>

        <Grid size={7}>
          <Skeleton variant="rounded" />
        </Grid>

        <Grid size={6}>
          <Skeleton variant="rounded" />
        </Grid>

        <Grid size={6}>
          <Skeleton variant="rounded" />
        </Grid>

        <Grid size={6}>
          <Skeleton variant="rounded" />
        </Grid>

        <Grid size={6}>
          <Skeleton variant="rounded" />
        </Grid>
      </Grid>
    </OrderCard>
  );
}
